import Style from './ZppCourseRemoveTeaser.style';
import { Span } from 'components/Common';
import { getColorSetByPrimaryColor } from 'utils';
import { TEXT } from 'locales/translations';

export const ZppCourseRemoveTeaser = ({ color, small = false }) => {
  const { darkestColor } = getColorSetByPrimaryColor(color);
  return (
    <Style backgroundColor={darkestColor} className={`zpp-course-remove-teaser ${small ? 'small' : ''}`}>
      <Span className="small bold">{TEXT.zppCourseCard.disclaimer}</Span>
    </Style>
  );
};
